__turbopack_context__.v({
  "contentContainer": "casino-widget-container-module-sass-module__QzQjEW__contentContainer",
  "expanded": "casino-widget-container-module-sass-module__QzQjEW__expanded",
  "widget": "casino-widget-container-module-sass-module__QzQjEW__widget",
  "widgetContent": "casino-widget-container-module-sass-module__QzQjEW__widgetContent",
  "widgetHeader": "casino-widget-container-module-sass-module__QzQjEW__widgetHeader",
});
